module.exports = __webpack_public_path__ + "static/media/paymentAfterpay.9185862b.png";